// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-version {
  position: fixed;
  padding: 4px;
  right: 0;
  bottom: 0;
  opacity: 0.5;
  color: #222;
  z-index: 999;
  cursor: pointer;
}
.app-version:hover {
  opacity: 1;
}

.isLoading {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  -webkit-user-select: none;
          user-select: none;
  z-index: 2000;
  background: rgba(20, 20, 50, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.isLoading .text {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AACF;AAAE;EACE,UAAA;AAEJ;;AAEA;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,kCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AACF;AAAE;EACE,WAAA;AAEJ","sourcesContent":[".app-version {\n  position: fixed;\n  padding: 4px;\n  right: 0;\n  bottom: 0;\n  opacity: 0.5;\n  color: #222;\n  z-index: 999;\n  cursor: pointer;\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.isLoading {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  user-select: none;\n  z-index: 2000;\n  background: rgba(20, 20, 50, 0.25);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  .text{\n    color: #fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
